import { NAV_DRAWER, CLOSE_BUTTON_ALL, CLOSE_BUTTON_SHOW, LANGUAGE, ENTRARLOGIN, ENTRAR_WINDOW } from '../actions/navigation'
import Vue from 'vue'
import axios from 'axios'

const state = {
  janelaLateral: false,
  language: 'PT',
  logado: '',
  loginWindow: false,
  tabs: [
    {titulo: 'Novo', index: 1, icon: 'far fa-plus-square', to: '/novo' , acao: 'novox', vif: true },
    {titulo: 'Abrir', index: 2, icon: 'far fa-folder-open', to: '/novo', acao: 'abrix', vif: false },
    {titulo: 'Favoritos', index: 3, icon: 'far fa-star', to: '/novo', acao: 'favx', vif: false },
    {titulo: 'Fechar Dados de Projeto', index: 4, icon: 'far fa-times-circle', to: '/dados-de-projeto', acao: 'closex', vif: false },
    {titulo: 'Fechar Cap. de Carga', index: 5, icon: 'far fa-times-circle', to: '/capacidade-de-carga', acao: 'closex', vif: false },
    {titulo: 'Fechar Recalques', index: 6, icon: 'far fa-times-circle', to: '/recalques', acao: 'closex', vif: false }
  ],
}

const getters = {
  janelaLateral: state => state.janelaLateral,
  getTabs: state => state.tabs,
  getLanguage: state => state.language,
  getLoginWindow: state => state.loginWindow
}

const actions = {
  [NAV_DRAWER]: ({commit, dispatch}) => {
    commit(NAV_DRAWER,state.janelaLateral)
    console.log('NAV_DRAWER ACTION ACTUAL',state.janelaLateral)
    console.log('NAV_DRAWER ACTION SENT',state.janelaLateral)
  },
  [CLOSE_BUTTON_SHOW]: ({commit, dispatch},value) => {
    commit(CLOSE_BUTTON_SHOW, value)
  },
  [CLOSE_BUTTON_ALL]: ({commit, dispatch},value) => {
    commit(CLOSE_BUTTON_ALL)
  },
  [LANGUAGE]: ({commit, dispatch},value) => {
    console.log('ACTION: LINGUA ALTERADA PARA: '+value)
    commit(LANGUAGE,value)
  },
  [ENTRARLOGIN]: ({commit, dispatch},value) => {
    console.log('ACTION: ENTRAR: '+value)
    commit(ENTRARLOGIN,value)
  },
  [ENTRAR_WINDOW]: ({commit, dispatch},value) => {
    console.log('ACTION: ENTRAR_WINDOW: '+value)
    commit(ENTRAR_WINDOW,value)
  }
}

const mutations = {
  [NAV_DRAWER]: (state,change) => {
    if(change===false){var changed = true;}else{var changed = false;}
    console.log('NAV_DRAWER MUTATION RECEIVED',change)
    console.log('NAV_DRAWER MUTATION CHANGE TO',changed)
    state.janelaLateral = changed;
  },
  [CLOSE_BUTTON_SHOW]: (state,value) => {
    state.tabs[value.id].vif = value.value;
  },
  [LANGUAGE]: (state,value) => {
    state.language = value;
    console.log('MUTATIONS: LINGUA ALTERADA PARA: '+value)
  },
  [ENTRARLOGIN]: (state,value) => {
    state.logado = value;
    console.log('MUTATIONS: LOGADO PARA: '+value)
  },
  [ENTRAR_WINDOW]: (state,value) => {
    state.loginWindow = value;
    console.log('MUTATIONS: ENTRAR_WINDOW PARA: '+value)
  },
  [CLOSE_BUTTON_ALL]: (state) => {
    state.tabs[3].vif = false;
    state.tabs[4].vif = false;
    state.tabs[5].vif = false;
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js